import styled, { css } from 'styled-components'

import CommonStyledButton from '../common/styled/StyledButton'
import CommonStyledInput from '../common/styled/StyledInput'

export const StyledButton = styled(CommonStyledButton)``
export const StyledInput = styled(CommonStyledInput)``
